import { COLUMN_NAMES, Column } from "../../../shared";

const useColumnsToShowFunctions = (
  currTableColumns: Column[],
  setCurrTableColumns: (columns: Column[]) => void,
) => {
  const areDefaultColumns = currTableColumns.every(
    (column: any) => Boolean(column.isDefaultActive) === column.isActive,
  );

  const toggleActiveColumn = (name: COLUMN_NAMES) => {
    const currentColumns = [...currTableColumns];

    const updatedColumns = currentColumns.map((column: Column) =>
      column.name === name ? { ...column, isActive: !column.isActive } : column,
    );

    setCurrTableColumns(updatedColumns);
  };

  const restoreActiveColumns = () => {
    const updatedColumns = [...currTableColumns].map((column) => ({
      ...column,
      isActive: Boolean(column.isDefaultActive),
    }));

    setCurrTableColumns(updatedColumns);
  };

  return { areDefaultColumns, toggleActiveColumn, restoreActiveColumns };
};

export default useColumnsToShowFunctions;
